<template>
  <span @keydown="onKeyDown">
    <validated-input :label="label" :validate="validate" v-model="val" ref="input" :disabled="disabled" />
  </span>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      defualt: 'Number'
    },
    validate: {
      type: [String, Object],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {}
  },
  inject: ['$validator'],

  computed: {
    val: {
      get() {
        return this.value;
      },
      set(value) {
        let prevVal = value;
        if (value && value.match('-')) {
          value = '-' + value.replace('-', ''); //only on the begin
          if (prevVal !== value) {
            setTimeout(() => {
              this.$refs.input.$refs.input.$el.value = value;
            }, 100);
          }
        }
        this.$emit('input', value);
      }
    }
  },
  methods: {
    onKeyDown(e) {
      const exclude = [8, 9, 37, 38, 39, 40];
      if (exclude.indexOf(e.keyCode) > -1) {
      } else {
        let allowCharacter = ['.', '-'];
        if (allowCharacter.indexOf(e.key) > -1) {
          if (allowCharacter[0] === e.key && this.val && this.val.indexOf(allowCharacter[0]) > -1) {
            //allow only 1 dot
            e.preventDefault();
            e.stopPropagation();
          } else if (allowCharacter[1] === e.key && this.val && this.val.indexOf(allowCharacter[1]) > -1) {
            //allow only 1 defis
            e.preventDefault();
            e.stopPropagation();
          }
        } else {
          if (new RegExp(/[^0-9]/gi).test(e.key)) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
      }
    }
  }
};
</script>
